/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyCto } from '../../models/company-cto';

export interface GetCompanies$Json$Params {
  Name?: string;
  CompanyGuid?: string;
  CompanyId?: number;
  ApiCompanyId?: string;
}

export function getCompanies$Json(http: HttpClient, rootUrl: string, params?: GetCompanies$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyCto>>> {
  const rb = new RequestBuilder(rootUrl, getCompanies$Json.PATH, 'get');
  if (params) {
    rb.query('Name', params.Name, {});
    rb.query('CompanyGuid', params.CompanyGuid, {});
    rb.query('CompanyId', params.CompanyId, {});
    rb.query('ApiCompanyId', params.ApiCompanyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CompanyCto>>;
    })
  );
}

getCompanies$Json.PATH = '/company/search';
